import React from 'react';

export const StartLink = ({ className = '', testId }) => (
  <a className={`start ${className}`} href="#apply" data-testid={testId}>
    <b>APPLY TO BECOME A GURU</b>
    <span aria-hidden="true">↗</span>
  </a>
);
